import { useMemo } from 'react';
import { RoomWithMembers, User } from '../../common/types';

export function calculateMembers(rooms?: RoomWithMembers[]) {
  const members: User[] = [];
  const seenMembers: Set<string> = new Set();
  if (!rooms) {
    return members;
  }

  for (const room of rooms) {
    for (const member of room.members) {
      if (!seenMembers.has(member.userUuid)) {
        members.push(member);
        seenMembers.add(member.userUuid);
      }
    }
  }
  return members;
}

export function useMembers(rooms?: RoomWithMembers[]) {
  const members = useMemo(() => {
    return calculateMembers(rooms);
  }, [rooms]);
  return members;
}
